export default __webpack_public_path__ + "static/media/Sharp Nails.f62e320c.png";